import { createStore } from 'vuex'
import { navHelper } from "@/util/navHelper";

import auth from './auth'
import tenant from './tenant'
import userNotifications from './resources/userNotifications'
import games from './resources/games'
import sprints from './resources/sprints'
import actions from './resources/actions'
import activities from './resources/activities'
import missions from './resources/missions'
import goals from './resources/goals'
import achievements from './resources/achievements'
import victories from './resources/victories'
import rewards from './resources/rewards'
import claims from './resources/claims'
import posts from './resources/posts'
import tips from './resources/tips'
import hubspotContacts from './resources/hubspotContacts'
import hubspotCompanies from './resources/hubspotCompanies'
import hubspotDeals from './resources/hubspotDeals'

// NOTE: All modules should ALWAYS be namespaced

export default createStore({
	modules: {
		auth,	// Contains Nested Modules
		tenant,	// Contains Nested Modules
		userNotifications,
		games,
		actions,
		sprints,
		activities,
		missions,
		goals,
		achievements,
		victories,
		rewards,
		claims,
		posts,
		tips,
		hubspotContacts,
		hubspotCompanies,
		hubspotDeals,
	},
	state: {
		showAppLoader: true,
		nav: new navHelper()
	},
	actions: {},
	mutations: {
		SET_APP_LOADER(state, isLoading) { state.showAppLoader = isLoading; },
	}
})